/**
 * Testi italiani dello strumento «Usa o cambia template» della scheda «Strumenti» di un
 * progetto.
 */

/** Testi dello strumento. */
export const projectTemplate = {
  /** Titolo del blocco. */
  title: 'Template',
  /** Spiegazione sotto il titolo. */
  intro:
    'Scegli un template del tuo piano e scrivi cosa cambiare. Su un progetto vuoto il set parte dal template, su uno già avviato ne riprende lo stile senza cancellare il tuo lavoro.',
  /** Pulsante che apre il cassetto. */
  open: 'Usa o cambia template',
  /** Titolo del cassetto. */
  drawerTitle: 'Usa o cambia template',
  /** Avviso sopra i campi. */
  consent: 'Il set userà il template solo dopo questa richiesta. Puoi vedere le anteprime nella pagina Template.',
  /** Campi. */
  kind: 'Tipo',
  kindAll: 'Tutti',
  kindWeb: 'Sito web',
  kindMobile: 'App mobile',
  template: 'Template',
  templateHelp: 'I template con il lucchetto richiedono un abbonamento Base o Premium.',
  templatePlaceholder: 'Scegli un template',
  noTemplates: 'Nessun template di questo tipo.',
  lockedOption: '{{name}} (richiede Base o Premium)',
  changes: 'Cosa cambiare',
  changesHelp: 'Per esempio colori, caratteri, stile, logo, pagine da togliere o da aggiungere. Facoltativo.',
  set: 'Set',
  noSet: 'Il progetto non è in nessun set. Aggiungilo a un set per usare un template.',
  /** Pulsante di invio. */
  submit: 'Invia al set',
  /** Esiti. */
  sentToast: 'Richiesta inviata.',
  sent: 'Richiesta inviata al set «{{set}}». La risposta arriva nella conversazione dell’Institore.',
  sendFailed: 'Invio non riuscito. Riprova.',
  loadFailed: 'Caricamento dei template non riuscito. Riprova.',
  setsFailed: 'Caricamento dei set non riuscito. Riprova.',
  /** Messaggio al set. */
  message: {
    use: 'Usa il template «{{name}}» ({{id}}) per il progetto «{{project}}».',
    changes: 'Cosa cambiare: {{changes}}',
    noChanges: 'Nessuna modifica richiesta: tieni colori e stile del template.',
  },
};

/** Forma dei testi dello strumento. */
export type ProjectTemplate = typeof projectTemplate;
